<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="users"
          class="elevation-1"
          :sort-by="['email']"
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar dark color="primary">
              <v-toolbar-title>Users</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:[`item.permissions`]="{ item }">
            <v-chip-group>
              <v-chip
                v-for="(value, permission) in item.permissions"
                :key="permission"
                :color="value ? 'green' : 'red'"
                @click="updatePermission(item, permission)"
              >
                {{ camelCaseToWords(permission) }}
              </v-chip>
            </v-chip-group>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      <v-icon class="mr-2">{{ snackbarIcon }}</v-icon> {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  data() {
    return {
      users: [],
      snackbar: false,
      snackbarText: "",
      snackbarIcon: "",
      snackbarColor: "",
      headers: [
        {
          text: "Name",
          align: "end",
          sortable: false,
          value: "first_name",
        },
        {
          text: "",
          value: "last_name",
          align: "start",
          sortable: false,
        },
        {
          text: "Email",
          value: "email",
          sortable: false,
        },
        {
          test: "Permissions",
          value: "permissions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    loadData() {
      axios.get("/api/v1/user/list").then((response) => {
        this.users = response.data;
      });
    },
    updatePermission(user, permission) {
      user.permissions[permission] = !user.permissions[permission];
      axios
        .post("/api/v1/user/update", user)
        .then(() => {
          this.loadData();
          this.snackbar = true;
          this.snackbarText = "Permissions updated";
          this.snackbarIcon = "mdi-check";
          this.snackbarColor = "success";
        })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarText = err.response.data;
          this.snackbarIcon = "mdi-alert";
          this.snackbarColor = "error";
        });
    },
    camelCaseToWords(camelCase) {
      return camelCase
        .match(/^[a-z]+|[A-Z][a-z]*/g)
        .map(function (x) {
          return x[0].toUpperCase() + x.substr(1).toLowerCase();
        })
        .join(" ");
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped></style>
